import React from 'react';
import {createRoot} from 'react-dom/client';
import {HashRouter} from 'react-router-dom';
import 'assets/scss/style.scss';
import App from 'layout/App';
import './util/i18n';
import {RecoilRoot} from 'recoil';

const root = createRoot(document.getElementById('root'));

root.render(
    <RecoilRoot>
        <HashRouter>
            <App/>
        </HashRouter>
    </RecoilRoot>
);

